import React from "react";
import ActionButton from "../partials/ActionButton";
import StagesManager from "../StagesManager";
import FormViewer from "../FormViewer";
import ViewSwitcher from "../ViewSwitcher";
import ViewsMenu from "../header/ViewsMenu";
import { chooseFontColor, imageAddress, textVariableReplacer, translate } from "../../utils/useful";
import ButtonAnimated from "../buttons/ButtonAnimated";
import HttpServices from "../../utils/Http.services";
import RecordViewerModal from "../../modals/RecordViewerModal";
import { saveAs } from 'file-saver';
import * as actions from '../../stores/actionsList';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

class FormWidget extends React.Component {
    state = {

        limit: 12,
        skip: 0,
        currentView: "table",
        // pje: [
        //     { name: '1Attend a business meeting ...', dec: 'Attend a business meeting Attend a business meeting Attend a business meeting Attend a business meeting', time: '6:30 am', img: "/images/p1.png", img2: "/images/p3.png" },
        //     { name: '1Reading Book', dec: 'Attend a business meeting Attend a business meeting Attend a business meeting Attend a business meeting', time: '10:30 pm', img: "/images/p2.png", img2: "/images/p1.png" },
        //     { name: '1Reading Book', dec: 'Attend a business meeting Attend a business meeting Attend a business meeting Attend a business meeting', time: '5:00 pm', img: "/images/p4.png", img2: "/images/p5.png" },
        //     { name: 'Attend a business meeting ...', dec: 'Attend a business meeting Attend a business meeting Attend a business meeting Attend a business meeting', time: '1:30 am', img: "/images/p7.png", img2: "/images/p6.png" },
        //     { name: 'Reading Book', dec: 'Attend a business meeting Attend a business meeting Attend a business meeting Attend a business meeting', time: '10:30 pm', img: "/images/p1.png", img2: "" },
        //     { name: 'Attend a business meeting ...', dec: 'Attend a business meeting Attend a business meeting Attend a business meeting Attend a business meeting', time: '10:30 am', img: "/images/p1.png", img2: "/images/p8.png" },

        // ],
        category: [
            { bg: "bg-red-300", name: "All", title: "Attend a business meeting ...", des: "meeting Attend a business meeting Attend a business meeting Attend a business meeting", title1: "Do somthing", des1: "meeting Attend a business meeting Attend a business meeting Attend a business meeting", },
            { bg: "bg-red-300", name: "Pending", title: "Attend a business meeting ...", des: "meeting Attend a business meeting Attend a business meeting Attend a business meeting", title1: "Exercise", des1: "meeting Attend a business meeting Attend a business meeting Attend a business meeting", },
            { bg: "#99FFFF", name: "Open", title: "Reading Book", des: "meeting Attend a business meeting", title1: "Painting", des1: "meeting Attend a business meeting Attend a business meeting Attend a business meeting", },
            { bg: "#DF73FF", name: "Closed", title: "Attend a business meeting ...", des: "choose the best option and create a pleasant shopping experience. .", title1: "Do somthing", des1: "meeting Attend a business meeting Attend a business meeting Attend a business meeting", },

        ],
        actions: {
            edit: { key: "edit", label: '{{lang}}edit', color: '#677dc4', function: this.openEditModal },
            remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: this.openRemoveModal }
        },
        headers: [
            // { key: 'title', type: 'TextInput', col: '12', information: { label: '{{lang}}Title', inplaceEditable: true, placeholder: '{{lang}}desk.insert', required: false, disabled: true }, showMain: true },
            // { key: 'dueDate', type: 'DateInput', col: '6', information: { label: '{{lang}}Assignee', inplaceEditable: true, placeholder: '{{lang}}desk.Date', required: true }, showMain: true },
            // { key: 'priority', type: 'StatusSelectInput', inPlaceEdit: true, information: { label: '{{lang}}Time', inplaceEditable: true, placeholder: '{{lang}}desk.priority', items: [{ label: '{{lang}}desk.High', key: 'high', color: '#CA5C72', bgColor: '#FEE9EE' }, { label: '{{lang}}desk.Medium', key: 'medium', color: '#CAA55C', bgColor: '#FEF2E9' }, { label: '{{lang}}desk.Low', key: 'low', color: '#00c875', bgColor: '#00c87520' }], required: false } },
            // { key: 'assignees', type: 'GlobalUserMultiInput', information: { label: '{{lang}}desk.Assignees', inplaceEditable: true, address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', isSearchable: true, placeholder: '{{lang}}desk.select', required: false, } },
            // { key: 'source', type: 'SelectInput', fullCol: true, information: { label: '{{lang}}desk.Source', inplaceEditable: true, required: true, type: 'local', default: '0', items: [{ title: "{{lang}}desk.Cash", value: 'C', color: '#789' }, { title: "{{lang}}desk.Credit Card", value: 'CC', color: '#789' },] }, showMain: true, inExport: true },
            // { key: 'tags', type: 'MultiSelectInput', fullCol: true, information: { label: '{{lang}}desk.Tags', inplaceEditable: true, required: true, type: 'local', default: '0', items: [{ title: "{{lang}}desk.Cash", value: 'C', color: '#789' }, { title: "{{lang}}desk.Credit Card", value: 'CC', color: '#789' },] }, showMain: true, inExport: true },

        ],


    }


    componentDidMount() {

        this.setState({ currentIndex: 0, currentItem: this.state.category[0] })
        this.init()
    }



    init() {

        let data = { ...this.props.data }
        this.setState({ information: data })
        let body = { collection: data.collection }

        this.setState({ isLoading: true })


        HttpServices.request("getFrame", body, (fetchResult, fetchError, status) => {
            // SocketServices.addTopic(this.state.topicId, this.props.data.thing, 'things', null, this.updateData)

            // console.log(fetchResult)
            this.setState({ isLoading: false })

            if (fetchError) { return }

            let frame = fetchResult?.info

            frame.key = frame._id
            frame.section = 'collections'
            frame.pageType = 'collection'
            frame.fetchUrl = 'getRecords'
            frame.addUrl = 'postRecord'
            frame.editUrl = 'postRecord'
            frame.removeUrl = 'removeRecord'
            frame.postBody = { hub: frame?.applet?.hub, applet: frame?.applet?._id }
            frame.filter = { hub: frame?.applet?.hub, applet: frame?.applet?._id }
            frame.fields.forEach(field => {
                field.information.disabled = this.props.editMode ? true : false
                if (!field.key.includes("values.")) {

                    field.key = "values." + field.key
                }
            });

            this.setState({ frame: frame }, () => { })

        })

    }


    functionsHandler = (type, name, data, extra, info) => {
        // console.log("functionsHandler")
        // console.log(type, name, data, extra)

        // if (!this.props.userView) {

        if (this[name]) {
            this[name](data, extra, info)
        }
        // }
        // else {
        //     console.log("functionsHandlerptop", this.props)
        //     console.log("functionsHandlerstate", this.state)
        // }
    }



    submitForm = (rawData, refresh, cb) => {

        if (!this.props.editMode && !this.state.isLoadingPost) {

            this.setState({isLoadingPost:true})
            let data
            if (!rawData) {
                data = this.form.getForm()
            } else {
                data = rawData
            }


            // console.log(data)

            if (data) {
                let page = this.state.frame
                let isEditing = data._id ? true : false
                let address = isEditing ? (page.editUrl ?? page.addUrl) : page.addUrl
                this.setState({ isPostingData: true })
                if (page.postBody) {
                    data = { ...data, ...page.postBody }
                }
                for (const [key, value] of Object.entries(data)) {
                    if (/\{\{(.*?)\}\}/.test(value)) {
                        if (this.props.variables) {
                            data[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                        }
                    }
                }
                data.frame = page?._id
                data.features = this.props.applet?.features
                // console.log('address', address)

                // return
                HttpServices.request(address, data, (fetchResult, fetchError, fetchStatus) => {

                    this.setState({isLoadingPost:false})

                    // console.log(fetchResult)
                    // console.log(fetchError)


                    this.setState({ isPostingData: false })
                    if (cb) {
                        cb()
                    }
                    if (fetchError) {
                        this.setState({ errors: fetchError.errors })
                        this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fetchError.message })
                        return
                    }
                    // this.modal.hideModal()
                    this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postDataSuccesfully', description: '{{lang}}info.dataUpdatedSuccessfully' })
                    this.stageManager.changeStage('submitted')
                })
            }
        }
    }










    render() {

        let colors = {
            primaryColor: '#5856d6',
            secondaryColor: '#7c7aff',
            textColor: '#fff'
        }

        let iconInvert = chooseFontColor(colors.textColor) == '#fff' ? true : false

        colors.iconInvert = iconInvert
        colors.background = `linear-gradient(90deg, ${colors.primaryColor}, ${colors.secondaryColor})`

        let view = this.props.data?.view ?? {}
        view.type = this.props.data?.type ?? 'table'

        let headersItemModal = null
        let variables = { ...this.props.variables }
        // variables.frameId = this.state.currentRelevantTab ?? this.props.page?._id
        // variables.currentItem = this.state.relevantCurrentItem ?? this.state.currentItem



        return (
            <div className=" w-100 h-100 d-flex flex-column" >
                <div className="flex-1" style={{ overflow: 'auto' }}>


                    <div className=" mt-0 br-10 w-100 flex-1 " style={{ border: '1px solid #eee' }}>
                        <StagesManager ref={el => this.stageManager = el} fast={true}>



                            <div className='pt-3 flexc flex-column pb-3' stage={0} stageName={'form'}>

                                <div className="w-100 px-3 mb-2 flexc">
                                    <button className="br-4 px-3 py-3 mt-1 mb-2 w-100 flexc  br-8" style={{ color: "#fff", background: 'linear-gradient(to right, rgb(88, 86, 214), rgb(124, 122, 255))', boxShadow: '0px 0px 20px #00000010' }}>
                                        <img className="invert mrd-2" src="/assets/icons/useful/stack1.png" alt="" height={20} />
                                        <p className="text-small text-semibold">2 records submitted previously for this form. <span style={{ textDecoration: 'underline' }}>View records</span>?</p>
                                    </button>
                                </div>
                                <FormViewer
                                    ref={el => this.form = el}
                                    applet={this.state.frame?.applet}
                                    headers={this.state.frame?.fields ?? this.state.page?.headers}
                                    data={this.state.data}
                                    top={29}
                                    actions={this.state.actions}
                                    width={this.props.width}
                                    functionsHandler={this.functionsHandler}
                                    errors={this.state.errors}
                                    formClass="modern-form"
                                    inputClass={'modern-input'}
                                    variables={this.props.variables}
                                    // stackedKey={this.props.stackedKey}
                                    view={this.state.view}
                                />

                                <div className='px-3 flexce flexc-wrap w-100'>


                                    <ButtonAnimated
                                        iconwidth='24px'
                                        onClick={() => { this.submitForm() }}
                                        title={translate("Submit")}
                                        textColor={'#fff'}
                                        bg={'linear-gradient(to right, rgb(88, 86, 214), rgb(124, 122, 255))'}
                                        isLoading={this.state.isLoadingPost}
                                        // width={'100%'}
                                    />

                                    {/* <button onClick={() => this.submitForm()} className='px-1 py-1 mt-2 flexcb ' style={{ cursor: this.props.editMode ? 'not-allowed' : 'pointer', background: " linear-gradient(to right, rgb(88, 86, 214), rgb(124, 122, 255))", borderRadius: 6, color: '#fff', transition: 'all 0.5s', }}>
                                        <p className='text-small text-semibold mld-3 mrd-3 ' style={{ whiteSpace: 'nowrap' }}>{translate("Submit")}</p>
                                        <div className='flexcc mld-3 p-1' style={{ background: 'linear-gradient(to right, #ffffff10, #ffffff20)', borderRadius: 6 }}>
                                            <img className='invert' src='/assets/icons/plus.svg' height={18} alt="" />
                                        </div>
                                    </button> */}
                                </div>
                            </div>



                            <div className=' flexc flex-column ' stage={1} stageName={'submitted'}>
                                <div className="br-8 py-4 px-3 w-100 text-center flexcc flex-column" style={{ background: '#f6f6f6' }}>


                                    <p className=" text-big text-semibold ">Form submitted</p>
                                    <p className="text-small  mt-2" style={{ color: '#000000aa', maxWidth: 500 }}>Thanks, the form is submitted. We will contact you about your form. You can also use the tracker to be informed about the status of your request.</p>

                                    <button onClick={() => this.stageManager.changeStage('form')} className='px-2 py-1 mt-3 flexcb ' style={{ cursor: this.props.editMode ? 'not-allowed' : 'pointer', borderRadius: 6, color: '#007aff', transition: 'all 0.5s', }}>
                                        <p className='text-small text-semibold mld-3 mrd-3 ' style={{ whiteSpace: 'nowrap' }}>{translate("Submit a new form?")}</p>
                                    </button>

                                    <button className="br-4 px-3 py-1 mt-1 mb-2" style={{ color: "#007aff", }}>
                                        <p className="text-smaller ">2 records are submitted previously. View records?</p>
                                    </button>

                                </div>
                            </div>

                        </StagesManager>

                    </div>
                </div>


            </div >
        )
    }
}



// export default FormWidget;

const mapStateToProps = state => ({ settings: state.settings, user: state.user, connections: state.connections })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(FormWidget);